import React from 'react';
import LoadingSmall from '../../components/LoadingSmall.js';
import axios from 'axios';

class stats extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            'revenue': [],
            'total':0,
        }


    }

    componentWillMount() {
        axios.get('/managment/stats').then(res => {
            let total = 0;
            let lines = [];

            Object.keys(res.data.revenue).map((key) => {
                lines.push({
                    name:key,
                    total:res.data.revenue[key],
                });

                total += res.data.revenue[key];
            });


            this.setState({
                revenue:lines,
                total:total,
            });
        });
    }


    render() {
        return (
            <div>
                <table className="table">
                    <tbody>
                    {
                        this.state.revenue.map(line => {
                            return (
                                <tr key={line.name}>
                                    <td>{line.name}</td>
                                    <td>{Math.round((line.total))}</td>
                                </tr>
                            )
                        })
                    }

                    <tr>
                        <td>Total</td>
                        <td>{Math.round((this.state.total))}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}

export default stats;



// WEBPACK FOOTER //
// ./containers/adm/stats.js